
export interface WeatherValidationData {
  id: string;
  userId: string; // Anonymous UUID stored in localstorage
  timestamp: number;
  location: string;
  predictedCondition: string; // "Hujan" | "Tidak Hujan"
  actualCondition: string; // "Hujan" | "Tidak Hujan"
  rawForecast: string; // Original forecast string (e.g. "Hujan Ringan", "Berawan")
}

export const WEATHER_CONDITIONS = {
  RAIN: 'Hujan',
  NO_RAIN: 'Tidak Hujan'
};
